import type { ApiResponse } from "../types/api";
import { mockDentalCases, mockPatientList } from "../mocks/mockResponses";
import type {
  DentalCaseData,
  PatientListItem,
  DentalCaseJaws,
  RestorationPlan,
} from "../types/dental";

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const mockApiClient = {
  async getPatientList(): Promise<ApiResponse<PatientListItem[]>> {
    await delay(250);

    return {
      success: true,
      data: mockPatientList,
    };
  },

  async getDentalCase(caseId: string): Promise<ApiResponse<DentalCaseData>> {
    await delay(400);

    const found = mockDentalCases.find((item) => item.summary.caseId === caseId);

    if (!found) {
      return {
        success: false,
        data: {} as DentalCaseData,
        message: `Case not found for id: ${caseId}`,
      };
    }

    return {
      success: true,
      data: structuredClone(found),
    };
  },

  async saveDentalCaseData(
    caseId: string,
    jaws: DentalCaseJaws,
    restorationPlans: RestorationPlan[]
  ): Promise<ApiResponse<null>> {
    await delay(500);

    const found = mockDentalCases.find((item) => item.summary.caseId === caseId);

    if (!found) {
      return {
        success: false,
        data: null,
        message: `Case not found for id: ${caseId}`,
      };
    }

    found.jaws = structuredClone(jaws);
    found.restorationPlans = structuredClone(restorationPlans);

    return {
      success: true,
      data: null,
      message: "Saved successfully.",
    };
  },
};